import wixLocation from 'wix-location';
import wixData from 'wix-data';
import wixWindow from 'wix-window';


$w.onReady(function () {

	//Seleziona in partenza il giorno 1
	$w("#dataset1").setFilter(wixData.filter().eq("date","1 July"));

	$w('#repeater1').onItemReady(($item, itemData, index) => {
		//link title
		//let tradotta = encodeURIComponent(itemData["link-Sessions-title"]);
		//let tradotta = escape (itemData["link-Sessions-title"])
		//let tradotta = itemData["link-Sessions-title"]
		let mURL = escape (itemData["link-Sessions-title"]);
		let tradotta = 
		console.log (tradotta)
		$item("#titleText").html = '<a target="_blank" href="http://www.wcsj2019.eu' + tradotta + '"><h4>' + itemData.title + '</h4></a>'
		//$item("#titleText").html = '<a target="_blank" href="http://www.wcsj2019.eu' + itemData["link-Sessions-title"] + '"><h4>' + itemData.title + '</h4></a>'


		// Nascondi CODE, TYPE e THEME se vuoti
		if(itemData.code === undefined){
			$item("#codeText").hide();
			$item("#codeText").collapse();
		}
		if(itemData.type === undefined){
			$item("#typeText").hide();
			$item("#typeText").collapse();
		}
		if(itemData.theme === undefined){
			$item("#themeText").hide();
			$item("#themeText").collapse();
		}

		// Visualizza scritta SOLD OUT
		if(itemData.soldOut === "x"){
			//console.log (itemData.code + " = SOLD OUT")
			$item("#soldoutText").show();
			}

		// se c'è almeno un nome il button CREW viene mostrato
		if (itemData.code === undefined){  // perché i campi senza codice mostrano speakers inesistenti nel dataset
			$item("#crewButton").hide();
		}	else {
			wixData.query("Sessions")
				.include("organizer")
				.eq("code", itemData.code)
				.find()
				.then((result) => {
					var org = result.items[0].organizer.length;
					if (org !== 0) {
						$item("#crewButton").show();
					}
				})
			wixData.query("Sessions")
				.include("moderator")
				.eq("code", itemData.code)
				.find()
				.then((result) => {
					var mod = result.items[0].moderator.length;
					if (mod !== 0) {
						$item("#crewButton").show();
					}
				})
			wixData.query("Sessions")
				.include("speaker")
				.eq("code", itemData.code)
				.find().then((result) => {
					var spe = result.items[0].speaker.length;
					if (spe !== 0) {
						$item("#crewButton").show();
					}
				})
			}


		//box crew
		var collapsed = true;
		$item("#crewButton").onClick(() => {
			if (collapsed) {
			//  TABELLA ORGANIZERS
				wixData.query("Sessions").include("organizer").eq("code", itemData.code).find().then((result) => {
					let organizers = result.items[0].organizer;
					var tableData = [];
					var tableColumns = [
						{
    						"id": "thumb",
						    "label": "Thumb",
 						    "width": 45,
    						"type": "image",
   							"dataPath": "thumb",
						    "visible": true,
						},
						{
    						"id": "name",
						    "label": "Name",
 						    "width": 200,
    						"type": "richText",
							"dataPath": "name",
						    "visible": true,
						}
					];
					organizers.forEach((item) => {
						tableData.push({
							'thumb': item.thumb,
							'name': '<a href="' + item['link-Speakers-title'] + '" target="_blank">' + item.name + '</a>',
						});
					});

					//nascondi tabella se vuota
					if(tableData.length === 0){
						$item("#table1").hide();
						$item("#table1").collapse();
						//eventualmente aggiugere stringa "nessun dato da mostrare" o simile
					}
					//singolare plurale
					if(tableData.length === 1)
						$item("#text59").text = "ORGANIZER";
					else
						$item("#text59").text = "ORGANIZERS";

					$item("#table1").columns = tableColumns;
					$item("#table1").rows = tableData;
				});

			//  TABELLA MODERATORS	
				wixData.query("Sessions").include("moderator").eq("code", itemData.code).find().then((result) => {
					let moderators = result.items[0].moderator;
					var tableData = [];
					var tableColumns = [
						{
    						"id": "thumb",
						    "label": "Thumb",
 						    "width": 45,
    						"type": "image",
   							"dataPath": "thumb",
						    "visible": true,
						},
						{
    						"id": "name",
						    "label": "Name",
 						    "width": 200,
    						"type": "richText",
							"dataPath": "name",
						    "visible": true,
						}
					];
					moderators.forEach((item) => {
						tableData.push({
							'thumb': item.thumb,
							'name': '<a href="' + item['link-Speakers-title'] + '" target="_blank">' + item.name + '</a>',
						});
					});

					//nascondi tabella se vuota
					if(tableData.length === 0){
						$item("#table2").hide();
						$item("#table2").collapse();
						//eventualmente aggiugere stringa "nessun dato da mostrare" o simile
					}
					//singolare plurale
					if(tableData.length === 1)
						$item("#text60").text = "MODERATOR";
					else
						$item("#text60").text = "MODERATORS";

					$item("#table2").columns = tableColumns;
					$item("#table2").rows = tableData;
				});

			//  TABELLA SPEAKERS
				wixData.query("Sessions").include("speaker").eq("code", itemData.code).find().then((result) => {
					let speakers = result.items[0].speaker;
					var tableData = [];
					var tableColumns = [
						{
    						"id": "thumb",
						    "label": "Thumb",
 						    "width": 45,
    						"type": "image",
   							"dataPath": "thumb",
						    "visible": true,
						},
						{
    						"id": "name",
						    "label": "Name",
 						    "width": 200,
    						"type": "richText",
							"dataPath": "name",
						    "visible": true,
						}
					];
					speakers.forEach((item) => {
						tableData.push({
							'thumb': item.thumb,
							'name': '<a href="' + item['link-Speakers-title'] + '" target="_blank">' + item.name + '</a>',
						});
					});

					//nascondi tabella se vuota
					if(tableData.length === 0){
						$item("#table3").hide();
						$item("#table3").collapse();
						//eventualmente aggiugere stringa "nessun dato da mostrare" o simile
					}
					//singolare plurale
					if(tableData.length === 1)
						$item("#text61").text = "SPEAKER";
					else
						$item("#text61").text = "SPEAKERS";

					$item("#table3").columns = tableColumns;
					$item("#table3").rows = tableData;
				});
				
			// mostra o nascondi il box Crew
			$item("#box3").show();
			$item("#box3").expand();
			collapsed = false;
			} else {
				$item("#box3").hide();
				$item("#box3").collapse();
				collapsed = true;
				}
		});  
	});
});

export function dateDropdown_change(event) {
	wixWindow.scrollTo(0, 0);
	let day = $w("#dateDropdown").value;
	$w("#dataset1").setFilter(wixData.filter().eq("date",day));
	console.log (day)
	} 

export function pagination1_click(event) {
	wixWindow.scrollTo(0, 0); 
	}